import { render } from "./FCM.vue?vue&type=template&id=1ed94592"
import script from "./FCM.vue?vue&type=script&lang=js"
export * from "./FCM.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__